import { Modal } from "tailwindcss-stimulus-components"
export default class extends Modal {

    remove(event) {
        this.element.remove()
    }

    requestRemove() {
      let confirmed = confirm("Are you sure you want to close?")
      if (confirmed) {
        this.remove()
      }
    }
}

